import { useEffect } from "react";

export default function useTitle(title?: string, useDefaultTitle?: boolean) {
  return useEffect(() => {
    if (useDefaultTitle) {
      document.title = "Knowfully Admin";
      return;
    }

    if (!title) return;

    document.title = `${title} - Knowfully Admin`;
  }, [title, useDefaultTitle]);
}
